/* global axios */
import ApiClient from './ApiClient';

class LifecycleStagesAPI extends ApiClient {
  constructor() {
    super('lifecycle_stages', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { lifecycle_stage: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { lifecycle_stage: data });
  }

  reorder(stages) {
    return axios.post(`${this.url}/reorder`, { stages });
  }
}

export default new LifecycleStagesAPI();
